import React, { createContext, useContext, useState, useCallback } from "react";
import { translations, type Lang } from "./translations";
type Dict = (typeof translations)["es"];
interface LanguageContextValue {
  lang: Lang;
  setLang: (l: Lang) => void;
  toggleLang: () => void;
  t: Dict;
}
const LanguageContext = createContext<LanguageContextValue | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [lang, setLangState] = useState<Lang>("es");
  const setLang = useCallback((l: Lang) => {
    setLangState(l);
    if (typeof document !== "undefined") {
      document.documentElement.lang = l;
    }
  }, []);
  const toggleLang = useCallback(() => {
    setLangState(prev => {
      const next = prev === "es" ? "en" : "es";
      if (typeof document !== "undefined") document.documentElement.lang = next;
      return next;
    });
  }, []);
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    toggleLang,
    t: translations[lang]
  }} data-id="element-250" data-mp="2qaasknzm4sv4">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
}